<template>
  <v-dialog
    v-model="dialog"
    persistent
    :overlay="false"
    max-width="350px"
    transition="dialog-transition"
  >
    <template #activator="{on}">
      <v-btn class="warning" :disabled="disabled" v-on="on" block dark
        >Old Balance Entry</v-btn
      >
    </template>
    <v-card>
      <v-toolbar dark dense primary-title class="warning">
        <v-toolbar-title class="text-truncate">
          {{ client.Name }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-5">
        <v-form ref="oldBalaceForm">
          <BaseDate outlined label="Date" v-model="oldblce.date"></BaseDate>

          <BaseNumInput
            :rules="[paymentRule]"
            append-icon="fas fa-hand-holding-usd"
            outlined
            solo
            v-model.trim="oldblce.Amount"
            label="Debt Amount"
          ></BaseNumInput>

          <v-text-field
            outlined
            solo
            append-icon="fas fa-comment"
            :rules="[v => !!v || 'Details is require']"
            name="DetailsOldblceName"
            label="Info"
            id="DetailsOldblceID"
            v-model="oldblce.Details"
          ></v-text-field>
        </v-form>
        <p
          v-if="ErrMsg"
          v-html="ErrMsg"
          class="error--text text-center d-block"
        ></p>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :loading="clicked"
          @click="OsavePayment"
          width="200"
          color="warning"
          dark
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    OnFinished: { type: Function, required: true },
    client: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      BaseURL: "/customer/oldblce",
      ErrMsg: "",
      dialog: false,
      clicked: false,
      oldblce: { date: "", Amount: 0, Details: null },
    };
  },
  methods: {
    close() {
      this.dialog = false;
      this.ErrMsg = "";
      this.oldblce.Details = "";
      this.oldblce.Amount = 0;
      this.oldblce.date = this.Current().date;

      this.$refs.oldBalaceForm.resetValidation();
    },
    OsavePayment() {
      this.ErrMsg = "";
      if (this.$refs.oldBalaceForm.validate()) {
        this.clicked = true;
        // this.oldblce.date = this.Current().date;
        this.oldblce.time = this.Current().time;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: this.BaseURL,
            data: { ...this.oldblce, client: this.client._id },
          })
          .then(() => {
            this.OnFinished();
            this.close();
            this.clicked = false;
          })
          .catch(error => {
            // console.log(error);
            this.ErrMsg = error && error.response && error.response.data;
            this.clicked = false;
          });
      }
    },
    paymentRule(v) {
      //   v = v.replace(/,/g, "");
      let andCon = v && v.replace(/,/g, "") > 0;
      return andCon || "Invalid Amount";
    },
  },
  created() {
    this.oldblce.date = this.Current().date;
  },
};
</script>
